import { SATOSPortal } from "@/data-adapter/SATOSPortal";
import { NodeVersionComparison } from "@/features/procedures/model/procedure/NodeVersionComparison";
import { useQuery } from "@tanstack/react-query";

export class NodeQueryKeys {
	static readonly nodeVersionsComparison = "nodeVersionsComparison";
	static readonly nodes = "nodes";
	static readonly checklists = "checklists";
	static readonly importPlan = "importPlan";
}

export const useFetchImportPlan = (
	active: boolean,
	nodeId: number | undefined,
	checklistId: number | undefined,
) => {
	return useQuery({
		queryKey: [
			NodeQueryKeys.nodes,
			nodeId,
			NodeQueryKeys.checklists,
			checklistId,
			NodeQueryKeys.importPlan,
		],
		queryFn: () => SATOSPortal.GetImportPlan(nodeId!, checklistId!),
		enabled: active && (!!checklistId || !!nodeId),
	});
};

export const useFetchNodeVersionsComparison = (
	nodeId: number,
	procedureId: number,
	isActive: boolean,
) => {
	return useQuery<NodeVersionComparison, any>({
		queryKey: [NodeQueryKeys.nodeVersionsComparison, procedureId, nodeId],
		queryFn: () => SATOSPortal.GetNodeVersionsComparison(nodeId, procedureId),
		enabled: isActive,
	});
};
